import { useFormContext } from 'react-hook-form';
import { useEffect, useMemo } from 'react';
import { FormField } from '@/components/custom/erp';
import { usePhuongThucThanhToan } from '@/hooks';
import { FormMode } from '@/types/form';

interface EInvoiceTabProps {
  formMode: FormMode;
}

export default function EInvoiceTab({ formMode }: EInvoiceTabProps) {
  const { paymentMethods } = usePhuongThucThanhToan();
  const { setValue, watch } = useFormContext();

  const paymentMethodOptions = useMemo(
    () =>
      paymentMethods.map(paymentMethod => ({
        value: paymentMethod.uuid,
        label: paymentMethod.ten_pttt
      })),
    [paymentMethods]
  );

  const currentPaymentMethod = watch('ma_pttt');

  useEffect(() => {
    if (paymentMethodOptions.length > 0 && !currentPaymentMethod && formMode === 'add') {
      setValue('ma_pttt', paymentMethodOptions[0].value);
    }
  }, [paymentMethodOptions, currentPaymentMethod, setValue, formMode]);

  return (
    <div className='px-4'>
      <div className='flex flex-col justify-between lg:flex-row'>
        <div className='w-full space-y-2'>
          {/* Trạng thái HĐĐT */}
          <div className='w-full max-w-md'>
            <FormField
              label='Trạng thái HĐĐT'
              labelClassName='w-32'
              name='ma_tthddt'
              type='select'
              disabled={formMode === 'view'}
              options={[
                { value: '0', label: 'Không sử dụng' },
                { value: '1', label: 'Chờ phát hành' }
              ]}
            />
          </div>

          {/* Thanh toán */}
          <div className='w-full max-w-md'>
            <FormField
              label='Thanh toán'
              labelClassName='w-32'
              name='ma_pttt'
              type='select'
              disabled={formMode === 'view'}
              options={paymentMethodOptions}
            />
          </div>

          {/* Số hóa đơn */}
          <div className='w-full max-w-md'>
            <FormField
              label='Số hóa đơn'
              labelClassName='w-32'
              name='so_ct_hddt'
              type='text'
              disabled={formMode === 'view'}
            />
          </div>

          {/* Ngày hóa đơn */}
          <div className='w-full max-w-md'>
            <FormField
              label='Ngày hóa đơn'
              labelClassName='w-32'
              name='ngay_ct_hddt'
              type='date'
              disabled={formMode === 'view'}
            />
          </div>

          {/* Ký hiệu */}
          <div className='w-full max-w-md'>
            <FormField
              label='Ký hiệu'
              labelClassName='w-32'
              name='so_ct2_hddt'
              type='text'
              disabled={formMode === 'view'}
            />
          </div>

          {/* Mẫu hóa đơn */}
          <div className='w-full max-w-md'>
            <FormField
              label='Mẫu hóa đơn'
              labelClassName='w-32'
              name='ma_mau_ct_hddt'
              type='text'
              disabled={formMode === 'view'}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
